import { Component, Output, Input, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import * as _ from "lodash";

@Component({
    selector: 'ion-calendar',
    template: `        
    <ion-grid class="grey">
        <ion-row justify-content-center>
            <ion-col col-auto (click)="back()">
                <ion-icon ios="ios-arrow-back" md="md-arrow-back"></ion-icon>
            </ion-col>
            <ion-col col-auto>
                <div>{{monthLabels[displayMonth]}} {{displayYear}}</div>
            </ion-col>
            <ion-col col-auto (click)="forward()">
                <ion-icon ios="ios-arrow-forward" md="md-arrow-forward"></ion-icon>
            </ion-col>
        </ion-row>
    </ion-grid>
    <ion-grid >
        

        <ion-row>
            <ion-col class="center calendar-header-col" *ngFor="let head of weekHead">{{head}}</ion-col>
        </ion-row>

        <ion-row class="calendar-row" *ngFor="let week of weekArray;let i = index">
            <ion-col class="center calendar-col" (click)="daySelect(day,i,j)" 
            *ngFor="let day of week;let j = index" 
            [ngClass]="[day.isThisMonth?'this-month':'not-this-month',day.isToday?'today':'',day.isSelect?'select':'',day.isMissionDay?'mission-day':'']">
                <ion-grid class="day-grid">
                    <ion-row>
                        <ion-col><div class="day-number">{{day.date}}</div></ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col><div class="mission-ray" [hidden]="!day.isMissionDay"></div></ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-icon color="secondary" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'missing'" name="stopwatch"></ion-icon>
                            <fa-icon color="primary" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'opened'" name="sign-in"></fa-icon>
                            <fa-icon color="primary" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'checked-in'" name="sign-out"></fa-icon>
                            <ion-icon color="light2" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'empty'" name="stopwatch"></ion-icon>
                            <ion-icon color="success" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'checked-out'" name="checkmark"></ion-icon>
                            <ion-icon color="success" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'ok'" name="checkmark"></ion-icon>
                            <ion-icon color="danger" *ngIf="day.isMissionDay && day.missionDayInformation && day.missionDayInformation.state == 'canceled'" name="close-circle"></ion-icon>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>

    </ion-grid>
`
})

export class Calendar {

    @Output() onDaySelect = new EventEmitter<dateObj>();
    @Output() onLoaded = new EventEmitter<calendarObj>();
    @Output() onMonthChange = new EventEmitter<calendarObj>();


    currentYear: number;
    inited: boolean = false;

    currentMonth: number;

    currentDate: number;

    currentDay: number;

    displayYear: number;

    displayMonth: number;

    dateArray: Array<dateObj> = []; // 本月展示的所有天的数组

    weekArray = [];// 保存日历每行的数组

    lastSelect: number = 0; // 记录上次点击的位置

    // weekHead: string[] = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    weekHead: string[] = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
    monthLabels: string[] = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

    wholePlanning:any;
    externalEvent:any;

    @Input() planning: any;

    constructor() {
        this.currentYear = moment().year();
        this.currentMonth = moment().month();
        this.currentDate = moment().date();
        this.currentDay = moment().day();

    }

    ngOnInit() {
        this.today()
    }
    pushPlanning(planning) {

    }
    pushWholePlanning(planning)
    {
        this.wholePlanning = {};//planning;
        if(planning)
        {
            for(var p=0;p<Object.keys(planning).length;p++)
            {
                var pkey = Object.keys(planning)[p];
                var period = planning[pkey];
                var ymd = period.startAtString.split('-');
                if(!this.wholePlanning[parseInt(ymd[0])])
                    this.wholePlanning[parseInt(ymd[0])]={};
                if(!this.wholePlanning[parseInt(ymd[0])][parseInt(ymd[1])])
                    this.wholePlanning[parseInt(ymd[0])][parseInt(ymd[1])]={};
                if(period.days)
                for(var d=0;d<Object.keys(period.days).length;d++)
                {
                    var dkey = Object.keys(period.days)[d];
                    var day = period.days[dkey];
                    var ymdd = day.dateString.split('-');
                    this.wholePlanning[parseInt(ymd[0])][parseInt(ymd[1])][parseInt(ymdd[2])]=day;
                }
            }
        }

        if(!this.inited) {
            // Only init on first call
            this.displayYear = this.currentYear;
            this.displayMonth = this.currentMonth;
            this.inited=true;
        }
        this.createMonth(this.displayYear, this.displayMonth);
        /*for(let i=0;i<planning.length;i++)
        {
            let obj = planning[i];
            //let day = moment({ year: obj.year, month: obj.month-1, date: obj.day });
            //console.log(day);
            let todayIndex = _.findIndex(this.dateArray, {
                year: obj.year,
                month: obj.month-1,
                date: obj.day,
                isThisMonth: true
            });
            if(this.dateArray[todayIndex]) {
                this.dateArray[todayIndex].isToday = true;
                this.dateArray[todayIndex].isMissionDay = true;
            }
        }*/
    }

    // 跳转至今天
    today() {
        this.displayYear = this.currentYear;
        this.displayMonth = this.currentMonth;
        this.createMonth(this.currentYear, this.currentMonth);

        // 将今天标记为选择状态
        let todayIndex = _.findIndex(this.dateArray, {
            year: this.currentYear,
            month: this.currentMonth,
            date: this.currentDate,
            isThisMonth: true
        })
        this.lastSelect = todayIndex;
        this.dateArray[todayIndex].isSelect = true;

        this.onDaySelect.emit(this.dateArray[todayIndex]);
        this.externalEvent = {
            calendar: this,
            year: this.currentYear,
            month: this.currentMonth,
            date: this.currentDate,
        };
        this.onLoaded.emit(this.externalEvent);
    }
    isMissionDay(year,month,day){

        if(!this.wholePlanning)return false;
        var realMonth = month +1;
        //console.log(year+"-"+realMonth+"-"+day);

        if(this.wholePlanning[year] && this.wholePlanning[year][realMonth] && this.wholePlanning[year][realMonth][day] )
        return true;
        return false;
    }
    missionDayInformation(year,month,day){
        if(!this.wholePlanning)return {};
        var realMonth = month +1;
        if(this.wholePlanning[year] && this.wholePlanning[year][realMonth] && this.wholePlanning[year][realMonth][day] )
            return this.wholePlanning[year][realMonth][day];
        return {};
    }
    createMonth(year: number, month: number) {
        this.dateArray = [];// 清除上个月的数据
        this.weekArray = [];// 清除数据
        let firstDay;//当前选择月份的 1 号星期几,决定了上个月取出几天出来。星期日不用显示上个月，星期一显示上个月一天，星期二显示上个月两天
        let preMonthDays;// 上个月的天数
        let monthDays;// 当月的天数
        let weekDays: Array<dateObj> = [];

        firstDay = moment({ year: year, month: month, date: 1 }).day();
        // 上个月天数
        if (month === 0) {
            preMonthDays = moment({ year: year - 1, month: 11 }).daysInMonth();
        } else {
            preMonthDays = moment({ year: year, month: month - 1 }).daysInMonth();
        }
        // 本月天数
        monthDays = moment({ year: year, month: month }).daysInMonth();
        // 将上个月的最后几天添加入数组
        if (firstDay !== 1) { //星期日不用显示上个月
            if(firstDay==0)firstDay=7;
            let lastMonthStart = preMonthDays - (firstDay - 2) ;// 从上个月几号开始
            //console.log(lastMonthStart,preMonthDays,monthDays,firstDay);
            for (let i = 0; i < firstDay-1 ; i++) {
                //console.log("add");
                if (month === 0) {

                    this.dateArray.push({
                        year: year,
                        month: 11,
                        date: lastMonthStart + i,
                        isThisMonth: false,
                        isToday: false,
                        isSelect: false,
                        isMissionDay:this.isMissionDay(year,11,lastMonthStart + i),
                        missionDayInformation:this.missionDayInformation(year,11,lastMonthStart + i),
                    })
                } else {
                    //console.log(lastMonthStart + i);
                    this.dateArray.push({
                        year: year,
                        month: month - 1,
                        date: lastMonthStart + i,
                        isThisMonth: false,
                        isToday: false,
                        isSelect: false,
                        isMissionDay:this.isMissionDay(year,month-1,lastMonthStart + i),
                        missionDayInformation:this.missionDayInformation(year,month-1,lastMonthStart + i),
                    })
                }

            }
        }

        // 将本月天数添加到数组中
        for (let i = 0; i < monthDays; i++) {
            this.dateArray.push({
                year: year,
                month: month,
                date: i + 1,
                isThisMonth: true,
                isToday: false,
                isSelect: false,
                isMissionDay:this.isMissionDay(year,month,i+1),
                missionDayInformation:this.missionDayInformation(year,month,i+1),
            })
        }

        if (this.currentYear === year && this.currentMonth === month) {
            let todayIndex = _.findIndex(this.dateArray, {
                year: this.currentYear,
                month: this.currentMonth,
                date: this.currentDate,
                isThisMonth: true
            })
            this.dateArray[todayIndex].isToday = true;
        }

        // 将下个月天数添加到数组中，有些月份显示 6 周，有些月份显示 5 周
        if (this.dateArray.length % 7 !== 0) {
            let nextMonthAdd = 7 - this.dateArray.length % 7
            for (let i = 0; i < nextMonthAdd; i++) {
                if (month === 11) {
                    this.dateArray.push({
                        year: year,
                        month: 0,
                        date: i + 1,
                        isThisMonth: false,
                        isToday: false,
                        isSelect: false,
                        isMissionDay:this.isMissionDay(year,0,i+1),
                        missionDayInformation:this.missionDayInformation(year,0,i+1),
                    })
                } else {
                    this.dateArray.push({
                        year: year,
                        month: month + 1,
                        date: i + 1,
                        isThisMonth: false,
                        isToday: false,
                        isSelect: false,
                        isMissionDay:this.isMissionDay(year,month+1,i+1),
                        missionDayInformation:this.missionDayInformation(year,month+1,i+1),
                    })
                }

            }
        }

        // 至此所有日期数据都被添加入 dateArray 数组中

        // 将日期数据按照每 7 天插入新的数组中
        for (let i = 0; i < this.dateArray.length / 7 ; i++) {
            for (let j = 0; j < 7; j++) {
                //console.log(this.dateArray[i * 7 + j ],i,j);
                if(this.dateArray[i * 7 + j ])
                weekDays.push(this.dateArray[i * 7 + j ]);
            }
            this.weekArray.push(weekDays);
            weekDays = [];
        }
        //console.log('REAL CHANGE');
        this.onMonthChange.emit(this.externalEvent);
    }

    back() {
        // 处理跨年的问题
        if (this.displayMonth === 0) {
            this.displayYear--;
            this.displayMonth = 11;
        } else {
            this.displayMonth--;
        }
        this.createMonth(this.displayYear, this.displayMonth);
    }

    forward() {
        // 处理跨年的问题
        if (this.displayMonth === 11) {
            this.displayYear++;
            this.displayMonth = 0;
        } else {
            this.displayMonth++;
        }
        this.createMonth(this.displayYear, this.displayMonth);
    }

    // 选择某日期，点击事件
    daySelect(day, i, j) {
        if(this.dateArray[i * 7 + j ].isMissionDay ){
            if(this.lastSelect && this.dateArray[this.lastSelect])
            this.dateArray[this.lastSelect].isSelect = false;
            // 保存本次点击的项
            this.lastSelect = i * 7 + j ;
            this.dateArray[i * 7 + j ].isSelect = true;

            this.onDaySelect.emit(day);
        }
    }
    /*swipe(event)
    {
        if(event.direction === 2) {
            event.srcEvent.stopPropagation();
            event.preventDefault();
            this.forward();

        }
        if(event.direction === 4) {
            event.srcEvent.stopPropagation();
            event.preventDefault();
            this.back();

        }
    }*/
}

// 日历的每个格子
interface dateObj {
    year: number,
    month: number,
    date: number,//几号
    isThisMonth: boolean,//是否为当前选择的月份
    isToday?: boolean,
    isMissionDay?: boolean,
    missionDayInformation?: any,
    state?: boolean,
    isSelect?: boolean,
}
// 日历的每个格子
interface calendarObj {
    calendar: any,
    year: any,
    month: any,
    date: any,
}


// WEBPACK FOOTER //
// ./src/components/calendar/calendar.ts